Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[id=_token]').getAttribute('content');
